<template>
  <a-spin :spinning="isSideMenuLoading">
    <a-menu
      mode="inline"
      :selected-keys="[current]"
      :open-keys="openKeys"
      @click="selectMenu"
      @openChange="openMenu"
    >
      <template v-for="menu in menuInfo">
        <a-menu-item v-if="!menu.subset" :key="routeName(menu.id)">
          <a-icon :type="menu.icon" :theme="iconTheme" />
          <span>
            {{ $t(`${menu.name}`) }}
            <i v-if="menu.prompt && menu.prompt.count" class="prompt-round">
              <!-- {{ menu.prompt.count }} -->
            </i>
          </span>
        </a-menu-item>
        <a-sub-menu v-else :key="routeName(menu.id)">
          <span slot="title">
            <a-icon :type="menu.icon" :theme="iconTheme" />
            <span>
              {{ $t(menu.name) }}
              <i v-if="menu.prompt && menu.prompt.count" class="prompt-round">
                <!-- {{ menu.prompt.count }} -->
              </i>
            </span>
          </span>
          <a-menu-item v-for="list in menu.subset" :key="routeName(list.id)">
            <span>{{ $t(list.name) }}</span>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
    <p class="info">
      <span v-if="showVersion" class="version">V{{ version }}</span>
      (GMT+8)
    </p>
  </a-spin>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { routerMap } from '@GM/Layout/routerMap'
import { getObjectKey } from '@GUTIL/other'

export default {
  name: 'Sidebar',
  data() {
    return {
      current: '',
      openKeys: [],
      menuInfo: [],
      watchList: []
    }
  },
  computed: {
    ...mapGetters([
      'sideMenu',
      'isSideMenuLoading',
      'showVersion',
      'version',
      'iconTheme',
      'routeName',
      'subscribeResponse',
      'folderName'
    ]),
    currentRouterMap() {
      return routerMap[this.folderName]
    },
    allMenuKeys() {
      let result = []
      this.menuInfo.forEach(item => {
        result.push(item.id)
        if (item.subset && item.subset.length > 0) {
          result = result.concat(item.subset.map(subItem => subItem.id))
        }
      })
      return result
    }
  },
  watch: {
    $route(value) {
      // console.log("route", value);
      let obj = { key: value.name }
      if (value.name === 'Home') {
        this.selectMenu({ ...obj, keyPath: [value.name] })
      } else {
        this.selectMenu(obj)
      }
      this.$emit('routeWatch') //定義routeWatch事件 GlobalLayout 會呼叫到
    },
    sideMenu: {
      handler: function() {
        this.refreshMenu()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.reset()
  },
  methods: {
    ...mapActions(['SET_SIDE_MENU_PROMPT']),
    reset() {
      // let openNode = this.$route.path.match(/[^/]+(?=\/)/g)
      // openNode && (this.openKeys = openNode)
      // this.current = this.$route.name
      this.matchLastRouteName()
    },
    matchLastRouteName(currentName) {
      let lastMatchedName = currentName || this.$route.name
      let currentRouteKey = getObjectKey(this.currentRouterMap, lastMatchedName)
      if (!currentRouteKey) {
        this.current = ''
        return
      }

      let routeKey = '',
        appendKey = ''
      // KO2.1.1 => [KO2, 1, 1]
      currentRouteKey.split('.').forEach((str, idx) => {
        appendKey =
          idx == 0 ? appendKey.concat(`${str}`) : appendKey.concat(`.${str}`)
        if (this.allMenuKeys.indexOf(appendKey) > -1) {
          routeKey = appendKey
        }
      })
      this.current = this.currentRouterMap[routeKey]
    },
    refreshMenu() {
      let home = [
        {
          id: 'Home',
          name: 'i18n_home',
          icon: 'home'
        }
      ]
      this.menuInfo = home.concat(this.sideMenu)
    },
    selectMenu(e) {
      let isClose = e.keyPath && e.keyPath.length === 1
      this.matchLastRouteName(e.key)
      isClose && (this.openKeys = [])
      this.$router.push({ name: e.key })
    },
    openMenu(newOpenKeys) {
      //  open only one submenu
      if (newOpenKeys.length > 1 && newOpenKeys.length > this.openKeys.length) {
        newOpenKeys.shift()
      }
      this.openKeys = newOpenKeys
    },
    resetOpenKeys() {
      this.openKeys = []
    }
  }
}
</script>
